var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _circle4, _circle5, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgScratchHeaderLeft = function SvgScratchHeaderLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 119,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCA28",
    d: "M76.603 91l16.833 19.57-9.346 8.04-16.833-19.57z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#33BB40",
    d: "M42.255 45.53L46.617 34l24.166 9.143-4.362 11.53z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.255,
    cy: 106,
    r: 3,
    fill: "#FFCA28"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.255,
    cy: 71,
    r: 3,
    fill: "#368FFE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.255,
    cy: 34,
    r: 3,
    fill: "#FF5F01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.725 65.679l8.542 4.452 8.363-4.78-1.595 9.5 7.13 6.476-9.527 1.419-3.956 8.783-4.293-8.623-9.576-1.048 6.874-6.748-1.962-9.431z",
    fill: "#9B51E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.725 8.678l8.542 4.452 8.363-4.78-1.595 9.5 7.131 6.476-9.528 1.419-3.956 8.783-4.294-8.623-9.575-1.048 6.874-6.748-1.962-9.431zM130.78 94.451L107.255 80.91l6.15-10.685 23.525 13.542z",
    fill: "#FF5F01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#368FFE",
    d: "M174.427 23.835l-10.684-6.15L169.893 7l10.684 6.15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B51E0",
    d: "M169.14 70.673l-12.024 2.723-2.722-12.024 12.023-2.723z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.767,
    cy: 46.006,
    r: 3,
    transform: "rotate(-121.039 131.767 46.006)",
    fill: "#FFCA28"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.544,
    cy: 51.411,
    r: 3,
    transform: "rotate(-121.039 194.544 51.411)",
    fill: "#9B51E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.659 98.154l5.375-8.088-3.901-8.894 9.354 2.612 7.253-6.457.406 9.702 8.383 4.903-9.102 3.385-2.072 9.487-6.032-7.61-9.664.96z",
    fill: "#FFCA28"
  })));
};

export default SvgScratchHeaderLeft;